import { ContextMenuMESFProvider } from "@dexteel/mesf-core";
import { CatalogMaterialProvider } from "./CatalogMaterialContext";
import { CatalogMaterialPage } from "./CatalogMaterialPage";

type Props = {};
const CatalogMaterial = (props: Props) => {
	return (
		<CatalogMaterialProvider>
			<CatalogMaterialPage />
		</CatalogMaterialProvider>
	);
};
export default CatalogMaterial;
